import factoryLogger from '../../logger/index.js'
import PageMappersFactory from '../Mappers/factory.js'
import PageServicesFactory from '../Services/factory.js'
import GetPageNamePageUseCase from './GetPageNamePageUseCase.js'
import GetTargetPageNamePageUseCase from './GetTargetPageNamePageUseCase.js'

export default class PageUseCasesFactory {
  static getPageNamePageUseCase = ({config}) =>
    new GetPageNamePageUseCase({
      log: factoryLogger({prefix: 'GetPageNamePageUseCase'}),
      service: PageServicesFactory.getPageNamePageService({config})
    })

  static getTargetPageNamePageUseCase = ({config}) =>
    new GetTargetPageNamePageUseCase({
      mapper: PageMappersFactory.fromQueryStringToQueryParamsPageMapper(),
      service: PageServicesFactory.getPageNamePageService({config})
    })
}
